import React from 'react';
import { Box, LinearProgress, Paper, Stack, Typography } from '@mui/material';

interface SimpleKpiCardProps {
  title: string;
  total: number;
  avancePorcentaje: number;
}

const clampPercent = (value: number): number => {
  if (!Number.isFinite(value)) return 0;
  return Math.max(0, Math.min(100, value));
};

const SimpleKpiCard: React.FC<SimpleKpiCardProps> = ({ title, total, avancePorcentaje }) => {
  const percent = clampPercent(avancePorcentaje);

  return (
    <Paper variant="outlined" sx={{ p: 1, borderRadius: 1.5 }}>
      <Stack spacing={0.5}>
        <Typography variant="caption" color="text.secondary">
          {title}
        </Typography>
        <Box display="flex" justifyContent="space-between" alignItems="baseline">
          <Typography variant="body2" fontWeight={700}>
            {total}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            {percent.toFixed(0)}%
          </Typography>
        </Box>
        <LinearProgress variant="determinate" value={percent} sx={{ height: 6, borderRadius: 999 }} />
      </Stack>
    </Paper>
  );
};

export default SimpleKpiCard;
